const streamToBlob = (
  stream: ReadableStream,
  mimeType?: string
): Promise<Blob> => {
  const options = typeof mimeType === 'string' ? { type: mimeType } : undefined;
  return new Promise(resolve => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chunks: any[] = [];
    const reader = stream.getReader();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const processChunk = ({ done, value }: any) => {
      chunks.push(value);
      if (done) {
        resolve(new Blob(chunks, options));
        return;
      }
      reader.read().then(processChunk);
    };
    reader.read().then(processChunk);
  });
};
export default streamToBlob;
